// Each id travels in the GetList query string (~39 chars URL-encoded); 100 per request stays well under the API's 8 KB request-line limit.
export const GET_BY_IDS_BATCH_SIZE = 100;
